import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
	selector: 'au-ai-image-analysis-loading',
	templateUrl: './ai-image-analysis-loading.component.html',
	styleUrls: ['./ai-image-analysis-loading.component.scss'],
	standalone: true,
	imports: [CommonModule, MatIconModule, NgxTolgeeModule],
})
export class AiImageAnalysisLoadingComponent implements OnInit, OnDestroy {
	currentMessage = signal<string>('');

	private messages = [
		'ai_extracting_asset_details',
		'ai_identifying_key_features',
		'ai_saving_time_message',
		'ai_magic_dust_message',
		'ai_enriching_asset_data',
	];

	private currentIndex = 0;
	private messageInterval: NodeJS.Timeout;

	ngOnInit() {
		this.startMessageRotation();
	}

	ngOnDestroy() {
		if (this.messageInterval) {
			clearInterval(this.messageInterval);
		}
	}

	private startMessageRotation() {
		this.currentMessage.set(this.messages[0]);
		this.messageInterval = setInterval(() => {
			this.currentIndex = (this.currentIndex + 1) % this.messages.length;
			this.currentMessage.set(this.messages[this.currentIndex]);
		}, 3000);
	}
}
